interface ErrorMessageOptions {
  /** Selector for finding an invalid field */
  fieldSelector?: string;
  /** Selectors for focusable inputs inside invalid fields */
  focusableInputSelectors?: string[];
  /** Function to calculate the offset */
  getTopOffset?: (controlEl: HTMLElement) => number;
}

/**
 * Uses the provided options to determine the first invalid field
 * inside the given `element`.
 * If an invalid field is found, the field is scrolled into view.
 * If something is focusable inside the field, the input receives focus.
 *
 * @param element
 * @param opts
 */
export function scrollToFirstErrorMessage(
  element: HTMLElement,
  opts?: ErrorMessageOptions,
): void {
  const {
    fieldSelector = 'form .generic-form-field.ng-invalid',
    focusableInputSelectors = ['.form-field__input', 'canvas'],
    getTopOffset = (e: HTMLElement) =>
      e.getBoundingClientRect().top + window.scrollY,
  } = opts ?? {};
  const invalidField = element.querySelector<HTMLElement>(fieldSelector);

  if (invalidField) {
    // Focus a focusable field inside the invalid field
    focusableInputSelectors.find((selector) => {
      const focusableField = invalidField.querySelector<HTMLElement>(selector);
      if (focusableField) {
        focusableField.focus();
      }
      return !!focusableField;
    });

    window.scroll({
      top: getTopOffset(invalidField),
      left: 0,
      behavior: 'smooth',
    });
  }
}
